"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMouseGridXY = exports.getGridXY = exports.activateTarget = exports.update = exports.moveTargetOffset = exports.setTargetMode = exports.get = exports.setInputGamepad = exports.setInputKeyboard = exports.setInputMouse = exports.ERogueInputDevice = exports.ERogueTargetMode = void 0;
var sprites_sidecar_1 = require("../../../sprites/sprites-sidecar");
var spritesUtil_sidecar_1 = require("../../../sprites/spritesUtil-sidecar");
var rogueSpellFireball_sidecar_1 = require("../anims/rogueSpellFireball-sidecar");
var rogueSpellTeleport_sidecar_1 = require("../anims/rogueSpellTeleport-sidecar");
var rogueCamera_sidecar_1 = require("../camera/rogueCamera-sidecar");
var rogueMouseAreas_sidecar_1 = require("../monofont/rogueMouseAreas-sidecar");
var rogueMonsters_sidecar_1 = require("../monsters/rogueMonsters-sidecar");
var rogueDef_sidecar_1 = require("../rogueDef-sidecar");
var rogueLayers_sidecar_1 = require("../scene/rogueLayers-sidecar");
var ERogueTargetMode;
(function (ERogueTargetMode) {
    ERogueTargetMode[ERogueTargetMode["none"] = 0] = "none";
    ERogueTargetMode[ERogueTargetMode["fireball"] = 1] = "fireball";
    ERogueTargetMode[ERogueTargetMode["teleport"] = 2] = "teleport";
    ERogueTargetMode[ERogueTargetMode["look"] = 3] = "look";
})(ERogueTargetMode = exports.ERogueTargetMode || (exports.ERogueTargetMode = {}));
var ERogueInputDevice;
(function (ERogueInputDevice) {
    ERogueInputDevice[ERogueInputDevice["mouse"] = 0] = "mouse";
    ERogueInputDevice[ERogueInputDevice["keyboard"] = 1] = "keyboard";
    ERogueInputDevice[ERogueInputDevice["gamepad"] = 2] = "gamepad";
})(ERogueInputDevice = exports.ERogueInputDevice || (exports.ERogueInputDevice = {}));
function setInputMouse() {
    // console.log('setInputMouse')
    get().lastInputDevice = ERogueInputDevice.mouse;
}
exports.setInputMouse = setInputMouse;
function setInputKeyboard() {
    // console.log('setInputKeyboard')
    get().lastInputDevice = ERogueInputDevice.keyboard;
}
exports.setInputKeyboard = setInputKeyboard;
function setInputGamepad() {
    // console.log('setInputGamepad')
    get().lastInputDevice = ERogueInputDevice.gamepad;
}
exports.setInputGamepad = setInputGamepad;
var _obj = null;
function get() {
    if (!_obj) {
        _obj = create();
    }
    return _obj;
}
exports.get = get;
var create = function () {
    var imageCursor = spritesUtil_sidecar_1.spritesUtil.createImage(rogueLayers_sidecar_1.rogueLayers.getLayers().uiOnCam, sprites_sidecar_1.sprites.rogueBorder[0]);
    spritesUtil_sidecar_1.spritesUtil.scale(imageCursor, rogueDef_sidecar_1.rogueDef.scale);
    var imageTileBorder = spritesUtil_sidecar_1.spritesUtil.createImage(rogueLayers_sidecar_1.rogueLayers.getLayers().uiOnCam, sprites_sidecar_1.sprites.rogueBorder[0]);
    spritesUtil_sidecar_1.spritesUtil.scale(imageTileBorder, rogueDef_sidecar_1.rogueDef.scale);
    var obj = {
        imageCursor: imageCursor,
        imageTileBorder: imageTileBorder,
        mode: ERogueTargetMode.none,
        lastInputDevice: ERogueInputDevice.mouse,
        keyboardGridX: 0,
        keyboardGridY: 0,
    };
    return obj;
};
var setTargetMode = function (mode) {
    get().mode = mode;
    var p = rogueMonsters_sidecar_1.rogueMonsters.getPlayer();
    if (p) {
        get().keyboardGridX = p.x + 2;
        get().keyboardGridY = p.y;
    }
};
exports.setTargetMode = setTargetMode;
var moveTargetOffset = function (dx, dy) {
    var obj = get();
    obj.keyboardGridX += dx;
    obj.keyboardGridY += dy;
};
exports.moveTargetOffset = moveTargetOffset;
var update = function () {
    var obj = get();
    var mouse = rogueCamera_sidecar_1.rogueCamera.getAdjustedMousePosition();
    var mouseUI = rogueCamera_sidecar_1.rogueCamera.getUiMousePosition();
    if (rogueMouseAreas_sidecar_1.rogueMouseAreas.isMouseCapturedByMouseArea()) {
        obj.imageCursor.visible = false;
        obj.imageTileBorder.visible = false;
        return;
    }
    //let mouse = common.getPhaserScene().input.mousePointer
    obj.imageCursor.x = mouseUI.mx;
    obj.imageCursor.y = mouseUI.my;
    obj.imageCursor.visible = false;
    // get spot
    var _a = (0, exports.getGridXY)(), gridX = _a.gridX, gridY = _a.gridY;
    obj.imageTileBorder.x = gridX * rogueDef_sidecar_1.rogueDef.sizeX; //- rogueCamera.get().cameraX
    obj.imageTileBorder.y = gridY * rogueDef_sidecar_1.rogueDef.sizeY; //- rogueCamera.get().cameraY
    obj.imageTileBorder.visible = true;
    if (obj.mode === ERogueTargetMode.none) {
        if (obj.lastInputDevice !== ERogueInputDevice.mouse) {
            obj.imageTileBorder.visible = false;
        }
        else {
            obj.imageTileBorder.visible = true;
        }
    }
    if (obj.mode === ERogueTargetMode.look) {
        obj.imageTileBorder.visible = true;
    }
    if (obj.mode === ERogueTargetMode.fireball) {
        rogueSpellFireball_sidecar_1.rogueSpellFireball.rogueCursorFireball(gridX, gridY, false);
        // rogueGlyphs.write(gridX, gridY, '*', rogueDef.colors.orange)
    }
    if (obj.mode === ERogueTargetMode.teleport) {
        rogueSpellTeleport_sidecar_1.rogueSpellTeleport.rogueCursorTeleport(gridX, gridY, false);
        // rogueGlyphs.write(gridX, gridY, '*', rogueDef.colors.orange)
    }
};
exports.update = update;
var activateTarget = function () {
    var _a = (0, exports.getGridXY)(), gridX = _a.gridX, gridY = _a.gridY;
    var obj = get();
    if (obj.mode === ERogueTargetMode.fireball) {
        rogueSpellFireball_sidecar_1.rogueSpellFireball.rogueCursorFireball(gridX, gridY, true);
    }
    if (obj.mode === ERogueTargetMode.teleport) {
        rogueSpellTeleport_sidecar_1.rogueSpellTeleport.rogueCursorTeleport(gridX, gridY, true);
    }
    if (obj.mode === ERogueTargetMode.look) {
        // Do nothing
    }
    (0, exports.setTargetMode)(ERogueTargetMode.none);
};
exports.activateTarget = activateTarget;
var getGridXY = function () {
    var obj = get();
    if (obj.lastInputDevice === ERogueInputDevice.mouse) {
        return (0, exports.getMouseGridXY)();
    }
    else {
        return { gridX: obj.keyboardGridX, gridY: obj.keyboardGridY };
    }
};
exports.getGridXY = getGridXY;
var getMouseGridXY = function () {
    var mouse = rogueCamera_sidecar_1.rogueCamera.getAdjustedMousePosition();
    // let mouseUI = rogueCamera.getUiMousePosition()
    var gridX = Math.floor(mouse.max / rogueDef_sidecar_1.rogueDef.sizeX + 0.5);
    var gridY = Math.floor(mouse.may / rogueDef_sidecar_1.rogueDef.sizeY + 0.5);
    return { gridX: gridX, gridY: gridY };
};
exports.getMouseGridXY = getMouseGridXY;
